export default __webpack_public_path__ + "static/media/LondrinaSolid-Thin.41e993df.ttf";